import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { jsx as _jsx } from "react/jsx-runtime";
const NoResultsIllustration = () => /*#__PURE__*/_jsx(Illustration, {
  name: "empty-state-charts",
  alt: I18n.text('noResultsMessage'),
  marginBlockEnd: "200"
});
const PrimaryContent = () => /*#__PURE__*/_jsx("div", {
  children: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.emptyState.noFormsInFolderExplanation"
    })
  })
});
const EmptyStateFolder = () => /*#__PURE__*/_jsx(NavMarker, {
  name: "FORMS_DASHBOARD_NO_RESULTS",
  children: /*#__PURE__*/_jsx(EmptyState, {
    id: "forms-dashboard-no-results",
    "data-test-id": "forms-dashboard-no-results",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.state.emptyState.noFormsInFolder"
    }),
    primaryContent: /*#__PURE__*/_jsx(PrimaryContent, {}),
    secondaryContent: /*#__PURE__*/_jsx(NoResultsIllustration, {}),
    secondaryContentWidth: 200
  })
});
export default EmptyStateFolder;